export const ANSVARFORSIKRING = {
  nickname: 'PRODUCTS.ANSVARFORSIKRING.shortname',
  isHidden: true,
  properties: [
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO' },
    { name: 'objectName', key: 'OBJECT_NAME_B2B', group: 'OBJECT_INFO' },
    { name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' }
  ],
  icon:'ansvarsforsikring'
};
